import {all, call, fork, put, takeLatest} from 'redux-saga/effects'
import {generalError} from 'actions/index'
import types from 'actions/types'
import {
  addPrintTemplateFailure,
  addPrintTemplateSuccess,
  deletePrintTemplateSuccess,
  duplicatePrintTemplateSuccess,
  loadPrintTemplateFailure,
  loadPrintTemplatesFailure,
  loadPrintTemplatesSuccess,
  loadPrintTemplateSuccess,
  updatePrintTemplateFailure,
  updatePrintTemplateSuccess,
} from 'actions/printTemplates'
import {push} from 'react-router-redux'
import {getPrintTemplatesUrl, getPrintTemplateUrl} from 'helpers/url'
import {getPrintTemplateRouteTypeFromTemplateType} from 'helpers/printTemplates/enum'
import {get} from 'lodash'

export default (api) => {

  const printTemplateFields = {
    default: true,
    json: true,
  }

  function* loadPrintTemplate({printTemplateId}) {
    try {
      const response = yield call(api.printTemplates.getOne, printTemplateId, printTemplateFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const printTemplate = data.result
            yield put(loadPrintTemplateSuccess(printTemplate))
          },
          function* onFail(key, message, code) {
            yield put(loadPrintTemplateFailure(message, code))
            yield put(generalError(message))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* loadPrintTemplates() {
    try {
      const response = yield call(api.printTemplates.get, {}, {default: true})
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(loadPrintTemplatesSuccess(data.result))
          },
          function* onFail(key, message, code) {
            yield put(loadPrintTemplatesFailure(message, code))
            yield put(generalError(message))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* addPrintTemplate({printTemplate}) {
    try {
      const response = yield call(api.printTemplates.add, {printTemplate}, printTemplateFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const printTemplate = data.result[0]
            yield put(addPrintTemplateSuccess(printTemplate))

            const printTemplateId = get(printTemplate, 'id', null)
            const routeType = getPrintTemplateRouteTypeFromTemplateType(printTemplate.type)
            yield put(push(getPrintTemplateUrl(printTemplateId, routeType)))
          },
          function* onFail(key, message, code) {
            yield put(addPrintTemplateFailure(message, code))
            yield put(generalError(message))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* duplicatePrintTemplate({printTemplateId, printTemplate}) {
    try {

      const params = {
        printTemplateId,
        printTemplate,
      }

      const response = yield call(api.printTemplates.duplicate, params, printTemplateFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const printTemplate = data.result[0]
            yield put(duplicatePrintTemplateSuccess(printTemplate))

            const printTemplateId = get(printTemplate, 'id', null)
            const routeType = getPrintTemplateRouteTypeFromTemplateType(printTemplate.type)
            yield put(push(getPrintTemplateUrl(printTemplateId, routeType)))
          },
          function* onFail(key, message, code) {
            yield put(duplicatePrintTemplateSuccess(message, code))
            yield put(generalError(message))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* updatePrintTemplate({printTemplate, closeEditor}) {
    try {
      const response = yield call(api.printTemplates.update, {printTemplate}, printTemplateFields)
      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            const printTemplate = data.result[0]
            yield put(updatePrintTemplateSuccess(printTemplate))

            if (closeEditor) {
              const routeType = getPrintTemplateRouteTypeFromTemplateType(printTemplate.type)
              yield put(push(getPrintTemplatesUrl(routeType)))
            }

            if (printTemplate.default) {
              yield call(loadPrintTemplates)
            }
          },
          function* onFail(key, message, code) {
            yield put(updatePrintTemplateFailure(message, code))
            yield put(generalError(message))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* deletePrintTemplate({printTemplateId}) {
    try {
      const response = yield call(api.printTemplates.delete, {printTemplateId}, printTemplateFields)
      yield api.handleResponse(
          response,
          function* onOk() {
            yield put(deletePrintTemplateSuccess(printTemplateId))
          },
          function* onFail(key, message, code) {
            yield put(updatePrintTemplateFailure(message, code))
            yield put(generalError(message))
          })
    } catch (e) {
      console.error(e)
      yield put(generalError(e.message))
    }
  }

  function* myWatcher() {
    yield all([
      takeLatest(types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATE_ATTEMPT, loadPrintTemplate),
      takeLatest(types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATES_ATTEMPT, loadPrintTemplates),
      takeLatest(types.PRINT_TEMPLATES_ADD_PRINT_TEMPLATE_ATTEMPT, addPrintTemplate),
      takeLatest(types.PRINT_TEMPLATES_DUPLICATE_PRINT_TEMPLATE_ATTEMPT, duplicatePrintTemplate),
      takeLatest(types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_ATTEMPT, updatePrintTemplate),
      takeLatest(types.PRINT_TEMPLATES_DELETE_PRINT_TEMPLATE_ATTEMPT, deletePrintTemplate),
    ])
  }

  function* watcher() {
    yield fork(myWatcher)
  }

  return {
    watcher,
  }
}
